import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { api, formatApiError } from "@/api";

export default function AdminLogin() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("bi_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-obsidian-surface border border-slate-700 rounded-sm px-4 py-3 text-sm text-slate-100 placeholder:text-slate-600 focus:outline-none focus:border-gold/70 focus:ring-1 focus:ring-gold/30 transition-[border-color,box-shadow] duration-300";

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center px-4 grain relative" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md border hairline rounded-sm bg-obsidian-surface/80 backdrop-blur-md p-10"
      >
        <Link to="/" data-testid="admin-login-logo" className="flex items-center gap-3">
          <span className="flex items-center justify-center rounded-xl bg-gradient-to-br from-white via-[#F7F2E7] to-[#EDE4CF] px-2.5 py-1.5 ring-1 ring-gold/50 shadow-[0_0_22px_rgba(212,175,55,0.35)]">
            <img src="/assets/logo-emblem.png" alt="Bridge Intell" className="h-9 w-auto" />
          </span>
          <span className="font-serif text-lg tracking-[0.14em] uppercase text-slate-100">Bridge <span className="text-gold">Intell</span></span>
        </Link>
        <h1 className="mt-8 font-serif text-2xl text-slate-100" data-testid="admin-login-title">{t.admin.login}</h1>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t.admin.email} className={inputCls} data-testid="admin-login-email" />
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder={t.admin.password} className={inputCls} data-testid="admin-login-password" />
          {error && <p className="text-xs text-red-400" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full py-3 bg-gold text-obsidian text-sm font-medium tracking-wide rounded-full hover:bg-gold-light disabled:opacity-60 transition-colors duration-300">
            {t.admin.signIn}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
